// extracted by mini-css-extract-plugin
module.exports = {"btns":"purchaseDrawer_btns__n8uO7"};